module.exports = __webpack_public_path__ + "static/media/cloudupload.6ca37130.png";